import HeaderVector from "images/HeaderVector.svg";
import CentrumSilyLogo from "images/CentrumSilyLogo.svg";
import "./Header.scss";
import { Link, useLocation } from "react-router-dom";
import useClickedOutsideElement from "hooks/useClickedOutsideElement";

interface IHeader {
  headerAnimated: boolean;
  headerWasAnimated: () => void;
}

const Header = ({ headerAnimated, headerWasAnimated }: IHeader) => {
  const { isDropdownOpen, handleDropdown, menuRef, menuBtnRef } =
    useClickedOutsideElement();
  const location = useLocation();
  const navigateToPortal = () => {
    window.open(
      "https://centrumsily.gymmanager.io",
      "_blank",
      "noopener,noreferrer",
    );
  };

  const closeTabletMenu = () => {
    handleDropdown(false);
  };

  return (
    <header
      className={`${
        !headerAnimated
          ? "animateHeader topHeader"
          : "headerOpacityNormal topHeader"
      }`}
      onAnimationEnd={headerWasAnimated}>
      <div>
        <img
          src={HeaderVector}
          alt="Top Header Vector"
          className="topHeaderVector"
        />
        <div className="topHeaderTextPositions">
          <div className="topHeaderTextItems">
            <Link to="/" className="topHeaderTextItem">
              Strona Główna
            </Link>
            <Link to="/gallery" className="topHeaderTextItem">
              Galeria
            </Link>
            <img
              src={CentrumSilyLogo}
              alt="Centrum siły logo"
              className="topHeaderVectorLogo"
            />
            <Link to="/statute" className="topHeaderTextItem">
              Regulamin
            </Link>
            <div className="topHeaderTextItem" onClick={navigateToPortal}>
              Portal
            </div>
          </div>
        </div>
        <div className="topHeaderTabletMenu">
          <div
            ref={menuBtnRef}
            className={`burgerMenuStyle ${
              isDropdownOpen ? "burgerMenuOpen" : ""
            }`}
            onClick={() => handleDropdown(!isDropdownOpen)}
            aria-label="Menu">
            <span className="burgerLine" />
            <span className="burgerLine" />
            <span className="burgerLine" />
          </div>
          <div
            className={`topHeaderTabletMenuContainer ${
              isDropdownOpen ? "topHeaderTabletMenuContainerOpen" : ""
            }`}
            ref={menuRef}
            onClick={closeTabletMenu}>
            {location.pathname == "/gallery" ? (
              <Link to="/" className="topHeaderTabletMenuItem">
                Strona Główna
              </Link>
            ) : (
              <Link to="/gallery" className="topHeaderTabletMenuItem">
                Galeria
              </Link>
            )}
            <Link to="/statute" className="topHeaderTabletMenuItem">
              Regulamin
            </Link>
            <div className="topHeaderTabletMenuItem" onClick={navigateToPortal}>
              Portal
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
